import {
  Box, LinearProgress, LinearProgressProps, Typography,
} from '@mui/material';
import React from 'react';

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {`${Math.round(
            // eslint-disable-next-line react/destructuring-assignment
            props.value,
          )}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const ProgressBar = ({ progress } : { progress: number }) => (
  <LinearProgressWithLabel value={progress} />
);

export default ProgressBar;
